$(document).ready(function() {
  // Show the first tab and hide the rest
  // $('#tabs-nav li:first-child').addClass('active');
  // $('.tabcontent').hide();  
  // $('.tab-content:first').show();
  
  //   // Product tab
  
  // // Show the first tab and hide the rest
  // $('#product-tabs-nav li:first-child').addClass('active');
  // $('.tab-content').hide();
  // $('.tab-content:first').show();
});


// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('#tabs-content .tabcontent').hide();
  
  var activeTab = $(this).find('a').attr('href');
  console.log("activeTab",activeTab);
  $(`#tabs-content ${activeTab}`).fadeIn();
  // return false;
});

// $('#destab').click(function(){
//   $('#tab2').hide();
//   $('#tab3').hide();
//   $('#tab4').hide();
//   $('#tab5').hide();
// });

// $('#manualtab').click(function(){
//   $('#tab1').hide();
//   $('#tab3').hide();
//   $('#tab4').hide();
//   $('#tab5').hide();
// });


// $('#specstab').click(function(){
//   $('#tab1').hide();
//   $('#tab2').hide();
//   $('#tab4').hide();
//   $('#tab5').hide();
// });

// $('#faqtab').click(function(){
//   $('#tab1').hide();
//   $('#tab2').hide();
//   $('#tab3').hide();
//   $('#tab5').hide();
// });
// $('#youtube_video').click(function(){
//   $('#tab1').hide();
//   $('#tab2').hide();
//   $('#tab3').hide();
//   $('#tab4').hide();
//   $('#tab5').show();
// });


// Click function
$('#product-tabs-nav li').click(function(){
  $('#product-tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});